import React, { useState } from 'react';
import PropTypes from 'prop-types';

function GroupsChooserSelectedGroup({ group, onDelete, className }) {
    const [classNameTransition, setClassName] = useState(className || '');
    const handleDelete = (group) => {
        setTimeout(() => onDelete(group), 400);
        setClassName(`${className || ''} is-transitioning`);
    };

    return (
        <li className={classNameTransition + (group.initiallySelected ? ' selected-groups__list-item--initial' : '')}>
            <span className="selected-groups__list-item-content">{group.name}</span>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <button
                type="button"
                className="sg-button-icon fa selected-groups__list-item-delete"
                title="Remove group from using this add-on"
                onClick={() => handleDelete(group)}
            >
                <i className="fa fa-trash-o" />
            </button>
        </li>
    );
}

GroupsChooserSelectedGroup.propTypes = {
    group: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
};

export default GroupsChooserSelectedGroup;
